<template>
  <div ref="currentWeekRef" class="current-week-indicator"></div>
</template>

<script setup>
import { throttle } from "lodash";
import { CURRENT_WEEK_RESIZE_OBSERVER_THROTTHLE } from "models/learning-objectives/learningObjectivesConstants";
import { onBeforeUnmount, ref, useTemplateRef, watchEffect } from "vue";

const currentWeekRef = useTemplateRef("currentWeekRef");
const timelineCalendar = ref(null);

const handleResize = throttle(() => {
  const { height: tCHeight, top: tCTop } =
    timelineCalendar.value.getBoundingClientRect();

  const { top: cWTop } = currentWeekRef.value.getBoundingClientRect();

  const height = tCHeight - (cWTop - tCTop);

  currentWeekRef.value.style.height = `${Math.floor(height)}px`;
}, CURRENT_WEEK_RESIZE_OBSERVER_THROTTHLE);

const resizeObserver = new ResizeObserver(handleResize);

watchEffect(async () => {
  if (currentWeekRef.value) {
    timelineCalendar.value = currentWeekRef.value.closest(".timeline-calendar");

    resizeObserver.observe(timelineCalendar.value);
  }
});

onBeforeUnmount(() => resizeObserver.disconnect());
</script>

<style lang="scss" scoped>
.current-week-indicator {
  @apply tw-pointer-events-none tw-absolute tw-top-full tw-z-10 tw-w-[2px] tw-select-none;
  background: rgba(249, 115, 22, 0.75);
}
</style>
